<template>
  <div class="allprjPrivi">
    <div v-for="(per, index) in permissionList" :key="index" class="permission">
      <div class="heard">
        <div class="firstTitle">
          <p class="line"></p>
          {{ per.title }}所有项目权限
        </div>
      </div>
      <div v-for="grup in per.data" :key="grup.prjRoleId" class="grupBox">
        <div class="grupNameStyle" @click="jumpPrjRole(grup)">
          <span title="点击查看或编辑此角色的权限" style="margin-right:2px">{{ grup.prjRoleName }}</span>
          <el-tooltip effect="light" content="请到 设置 - 权限管理 - 项目角色 中，查看或编辑此角色的权限">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
        <div>
          <div class="addBut addButrRole" @click="addRole(per.managerType,grup.prjRoleId)">
            <i class="el-icon-plus"></i>
            添加角色
          </div>
          <div v-if="grup.sysRoleList.length>0" class="content-people">
            <div v-for="row in grup.sysRoleList" :key="row.id" class="people-content">
              <div class="roleBox" @click="showPeople(row)">
                <div class="avatarBox">
                  <img class="avatar" :src="require('@/CommonDP/assets/approval/role.png')" alt="图片" />
                  <p> {{ row.roleName }} </p>
                </div>
                <div class="delRoleStyel" @click.stop="delRole(row,grup.prjRoleName)">
                  <img
                    :src="require('@/CommonDP/assets/approval/roleDel.svg')"
                    alt="图片"
                    style="width:10px;height:29px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="zanwu"> 暂无角色 </div>
        </div>
        <div>
          <div class="personNav">
            <span class="addBut" @click="addRolePersonHandler(per.managerType,grup.prjRoleId)">
              <i class="el-icon-plus"></i>
              添加人员
            </span>
            <el-checkbox v-model="grup.checked" style="margin-left:10px" @change="allCheck(grup.checked,grup.userList,index)">{{ grup.checked?"反选":"全选" }}</el-checkbox>
            <span class="batchDelete" @click="batchDeletion(grup.userList)"> <i class="el-icon-delete"></i> 批量删除</span>
            <el-input v-model="grup.input" size="small" placeholder="请输入名称搜索" prefix-icon="el-icon-search"
              style="width:200px;margin-left:10px;" clearable @input="changeinput(grup)" />
          </div>
          <div v-if="grup.userList.length>0" class="content-people">
            <userItem
              :userList="changeUserName(grup.userList)"
              :grup="grup"
              :from="'allprjPrivi'"
              @singleCheck="singleCheck"
              @deleteUser="delRolePersonHandler"
            ></userItem>
          </div>
          <div v-else class="zanwu"> 暂无人员 </div>
        </div>
      </div>
    </div>
    <selectSysRoleDlg ref="selectSysRoleDlg" :type="'allprjPrivi'" @ok="fetchData" />
    <el-dialog v-dialogDrag :visible.sync="peopleDialog" :before-close="peopleClose" :close-on-click-modal="false"
      :close-on-press-escape="false" title="人员" width="800px">
      <div class="rolePersonTabBox">
        <rolePersonTab ref="rolePersonTab" :checkboxShow="false" :heightNum="486"></rolePersonTab>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import priviService from "@/CommonDP/service/privi-service";
import { mapState } from "vuex";
import { disablePrompt } from "@/CommonDP/utils/routeAuth";
import selectSysRoleDlg from '@/CommonDP/pages/mainMg/settings/permission/components/selectSysRoleDlg.vue';
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import rolePersonTab from '@/CommonDP/pages/mainMg/settings/permission/components/rolePersonTab.vue';

export default {
  components: {
    selectSysRoleDlg,
    userItem,
    rolePersonTab
  },
  data() {
    return {
      roleList: [],
      depRoleList: [],
      peopleDialog: false,
      prjRoleId: ''
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      isShowBranch: state => state.enterprise.isShowBranch
    }),
    permissionList() {
      let list = [
        {
          title: "公司",
          managerType: 0,
          data: this.roleList
        },
        {
          title: "分支机构",
          managerType: 1,
          data: this.depRoleList
        }
      ];
      list = this.isShowBranch ? list : list.filter(
        (str) => str.title !== "分支机构"
      );
      return list;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.getRoleList(0);
      this.getRoleList(1);
    },
    // 添加人
    async addRolePersonHandler(managerType, prjRoleId) {
      const a = disablePrompt();
      if (a) {
        const props = {
          filterOneself: false,
          codePri: ["User"]
        };
        const user = await openMember(props);
        const { fetchData, enterpriseId } = this;
        const userIdList = user.map((item) => {
          return item.userId;
        });
        var params = {
          enterpriseId,
          userIdList,
          managerType,
          prjRoleId
        };
        await priviService.prjManagerAdd(params);
        await this.$message.success({ message: "添加人员成功" });
        fetchData();
      }
    },
    // 获取角色列表
    getRoleList(managerType) {
      const { enterpriseId } = this;
      return priviService
        .prjManagerRoleList(enterpriseId, managerType)
        .then(({ data }) => {
          data.checked = false;
          data.input = '';
          data.forEach(ele => {
            ele.userList.forEach(i => {
              i.$selectAll = 0;
            });
            ele.completePersonList = ele.userList;
          });
          if (managerType === 0) {
            this.roleList = data;
          } else {
            this.depRoleList = data;
          }
        });
    },
    // 删除角色
    async delRolePersonHandler(row) {
      const a = disablePrompt();
      const { enterpriseId } = this;
      if (a) {
        const { $message, fetchData } = this;
        const { id } = row;
        await priviService.prjManagerDelete(enterpriseId, id);
        await fetchData();
        await $message({ type: "success", message: "删除人员成功" });
      }
    },
    allCheck(checked, val, index) {
      val.forEach(ele => {
        ele.$selectAll = checked ? 1 : 0;
      });
    },
    batchDeletion(val) {
      const arr = val.filter(({ $selectAll }) => $selectAll === 1);
      const idList = arr.map(i => i.id);
      if (!idList.length) {
        this.$error("请选择人员");
        return;
      }
      const a = disablePrompt();
      const { enterpriseId } = this;
      if (a) {
        const { $confirm, $message, fetchData } = this;
        const params = { enterpriseId, idList };
        $confirm(`确定批量删除人员?`, "警告", {
          type: "warning"
        })
          .then(() => priviService.prjManagerBatchDeleteUser(params))
          .then(() => {
            fetchData();
            $message({ type: "success", message: "批量删除人员成功" });
          });
      }
    },
    singleCheck(grup) {
      const num = grup.userList.filter(({ $selectAll }) => $selectAll === 1).length;
      if (grup.userList.length > 0 && (num === grup.userList.length)) {
        grup.checked = true;
      } else {
        grup.checked = false;
      }
    },
    delRole(row, prjRoleName) {
      const a = disablePrompt();
      const { enterpriseId } = this;
      if (a) {
        const { $confirm, $message, fetchData } = this;
        const { id, roleName } = row;
        $confirm(`确定从此${prjRoleName}里移除角色 ${roleName}?`, "警告", {
          type: "warning"
        })
          .then(() => priviService.prjManagerDeleteRole(enterpriseId, id))
          .then(() => {
            fetchData();
            $message({ type: "success", message: "删除角色成功" });
          });
      }
    },
    changeinput(grup) {
      grup.completePersonList.forEach(ele => {
        ele.$selectAll = 0;
      });
      grup.userList = grup.completePersonList.filter((item) => this.filterKeyword(item, grup.input));
    },
    filterKeyword(item, name) {
      const keyArr = ["name"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },
    addRole(managerType, prjRoleId) {
      // managerType 0:所有 1:本分院
      this.$refs.selectSysRoleDlg.showDlg(managerType, prjRoleId);
    },
    peopleClose() {
      this.peopleDialog = false;
    },
    async showPeople(val) {
      this.peopleDialog = true;
      await this.$nextTick(() => {});
      const data = {
        roleID: val.roleId,
        roleName: val.roleName
      };
      this.$refs.rolePersonTab.queryPreson(data);
    },
    changeUserName(list) {
      return list.map((e) => {
        return {
          ...e,
          selectCode: "User",
          name: e.name + '(' + e.username + ')'
        };
      });
    },
    jumpPrjRole(grup) {
      const data = {
        roleID: grup.prjRoleId,
        roleName: grup.prjRoleName
      };
      this.$emit('setRoleType', data);
    }
  }
};
</script>
<style lang="scss" scoped>
.allprjPrivi {
  width: 100%;
  height: 100%;
  overflow-x: auto;
  padding: 0 16px;
  .heard {
    margin:var(--big-space);
    .line{
      display: inline-block;
      width:4px;
      height: 16px;
      background:#5587F0;
      margin-right: 8px;
    }
  }
  .firstTitle{
    font-size: 16px;
    color: var(--key-color);
    font-weight: bold;
    margin-right: 26px;
    display: flex;
    align-items:center;

  }

  .grupBox{
    border:1px solid #d4d2d2;
    padding:16px 16px 0px 16px;
    border-radius:15px;
    margin-top:16px;
    position: relative;
    .grupNameStyle{
      position: absolute;
      top: -12px;
      left: 17px;
      font-size: 14px;
      background: #e1eefb;
      border-radius:20px;
      padding: 3px 10px;
      cursor: pointer;
    }
    .grupNameStyle:hover{
      text-decoration: underline;
      color: var(--theme-color, #4777e7);
      text-underline-offset: 3px;
    }
    .personNav{
      margin-bottom: 8px;
    }
    .addBut{
      color: #4777e7;
      padding: 6px 0;
      font-size: 14px;
      cursor: pointer;
    }
    .batchDelete{
      margin-left:10px;
      font-size: 14px;
      cursor: pointer;
    }
    .addButrRole{
      margin-bottom: 8px;
      font-size: 14px;
      display: inline-block;
    }
  }
  .content-people {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    overflow: auto;
    margin-bottom: 8px;
    .people-content {
      display: flex;
      margin-right: 8px;
      align-items: center;
      max-width: 235px;
      font-size: 14px;
      margin-bottom: 5px;
    }
    .roleBox{
      width: 211px;
      height: 30px;
      background: #F5F7FA;
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      padding: 0 6px;
      cursor: pointer;
      .avatarBox{
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        align-items: center;
      }
      .avatar{
        margin-right: 4px;
        width:24px;
        height:24px
      }
      .delRoleStyel{
        width: 20px;
        height: 30px;
        text-align: center;
      }
    }
    .peopleBox{
      width: 232px;
      height: 40px;
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      align-items: center;
      position: relative;
      .people{
        width: 206px;
        height: 40px;
        border: 1px solid #E8EAEC;
        border-radius:34px;
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        align-items: center;
        margin-left: 8px;
        .username{
          width: 145px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .zanwu{
    margin-bottom: 8px;
    color: #909399;
    margin-left:10px
  }
  .rolePersonTabBox{
    padding:8px 8px 0 8px
  }
}
</style>
